export const ICON_OPTIONS = [
  "AlertCircle",
  "AlertTriangle",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowUpRight",
  "Award",
  "BarChart",
  "BarChart2",
  "BarChart3",
  "BookOpen",
  "Box",
  "Boxes",
  "Briefcase",
  "Building",
  "Building2",
  "Calculator",
  "Calendar",
  "CalendarDays",
  "Check",
  "CheckCircle",
  "CheckCircle2",
  "ChevronDown",
  "ChevronLeft",
  "ChevronRight",
  "ChevronUp",
  "Circle",
  "ClipboardList",
  "Clock",
  "Cloud",
  "Cog",
  "Copy",
  "CreditCard",
  "Database",
  "DollarSign",
  "Download",
  "Edit2",
  "Edit3",
  "ExternalLink",
  "Eye",
  "Facebook",
  "Factory",
  "File",
  "FileCheck",
  "FileText",
  "Filter",
  "Globe",
  "Grid3X3",
  "GripVertical",
  "Handshake",
  "HardHat",
  "Headphones",
  "Heart",
  "HeartHandshake",
  "HeartPulse",
  "ImageIcon",
  "Layers",
  "Lightbulb",
  "Link",
  "Link2",
  "Linkedin",
  "List",
  "Lock",
  "LogOut",
  "Magnet",
  "Mail",
  "Map",
  "MessageCircle",
  "Monitor",
  "Moon",
  "MoreHorizontal",
  "Package",
  "Palette",
  "PenTool",
  "Phone",
  "Plus",
  "Quote",
  "RefreshCw",
  "Rocket",
  "Rss",
  "Save",
  "Search",
  "Settings",
  "Shield",
  "ShieldCheck",
  "ShoppingBag",
  "ShoppingCart",
  "Star",
  "Sun",
  "Tag",
  "Target",
  "Trash2",
  "TrendingUp",
  "Truck",
  "Twitter",
  "Unlock",
  "Upload",
  "User",
  "UserPlus",
  "Users",
  "UtensilsCrossed",
  "Video",
  "Warehouse",
  "Wheat",
  "Wrench",
  "X",
  "Youtube",
  "Zap",
];